import { defineMessages } from 'react-intl';

export default defineMessages({
  useBackground: {
    id: 'Customize background color',
    defaultMessage: 'Customize background color',
  },
  backgroundColor: {
    id: 'backgroundColor',
    defaultMessage: 'Background color',
  },
  grey: {
    id: 'grey',
    defaultMessage: 'Grey',
  },
  darkBlue: {
    id: 'darkBlue',
    defaultMessage: 'Dark blue',
  },
  increasePadding: {
    id: 'increasePadding',
    defaultMessage: 'Increase padding',
  },
  fullWidth: {
    id: 'fullWidth',
    defaultMessage: 'Full width',
  },
  none: {
    id: 'none',
    defaultMessage: 'None',
  },
  background: {
    id: 'background',
    defaultMessage: 'Background',
  },
  contentAndBackground: {
    id: 'contentAndBackground',
    defaultMessage: 'Content and background',
  },
  selectLayout: {
    id: 'Select layout',
    defaultMessage: 'Select layout',
  },
  nColumns: {
    id: 'N columns',
    defaultMessage: '{numCols, plural, one {# column} other {# columns}}',
  },
  equal: {
    id: 'equal',
    defaultMessage: 'equal',
  },
});
